import { render, staticRenderFns } from "./CompanyNotificationForm.vue?vue&type=template&id=e0d36dd8&scoped=true&"
import script from "./CompanyNotificationForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyNotificationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyNotificationForm.vue?vue&type=style&index=0&id=e0d36dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d36dd8",
  null
  
)

export default component.exports